import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { BookOpen, Globe, Award, ArrowRight, HeartPulse } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pastorBio, aboutLinks, publicCtas } from '@/content/public-site-content';

export default function BiographyPage() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 p-6">
      <section className="rounded-[2rem] border border-border/70 bg-card/90 p-8 shadow-sm">
        <div className="space-y-4">
          <Badge variant="outline" className="mb-2 w-fit">
            <HeartPulse className="mr-1 h-3 w-3" />
            Biography
          </Badge>
          <h1 className="text-4xl font-bold tracking-tight">{pastorBio.name}</h1>
          <p className="max-w-3xl text-xl text-muted-foreground">
            {pastorBio.shortSummary} This page focuses on his calling, service, and the
            leadership journey that shaped Dominion Mandate.
          </p>
        </div>
      </section>

      <div className="grid gap-6 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="space-y-6">
          <Card className="border-primary/20 bg-primary/5">
            <CardHeader>
              <CardTitle className="text-2xl">Life and Calling</CardTitle>
              <CardDescription>
                The story behind the founder and the ministry he leads.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4 text-base leading-7 text-muted-foreground">
              {pastorBio.fullBio.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Award className="h-5 w-5 text-primary" />
                Ministry Roles
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-muted-foreground">
                {pastorBio.roles.map((role) => (
                  <li key={role}>• {role}</li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Globe className="h-5 w-5 text-primary" />
                Ministry Snapshot
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground leading-7">
                {pastorBio.tags}. His work spans teaching, consulting, and public leadership
                with a consistent emphasis on transformation.
              </p>
            </CardContent>
          </Card>

          <Card className="border-border/70">
            <CardHeader>
              <CardTitle className="text-lg">Family</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground leading-7">{pastorBio.family}</p>
            </CardContent>
          </Card>

          <Card className="border-border/70 bg-card/90">
            <CardHeader>
              <CardTitle className="text-lg">Explore More</CardTitle>
              <CardDescription>Continue with the testimony or vision pages.</CardDescription>
            </CardHeader>
            <CardContent className="flex flex-wrap gap-3">
              {aboutLinks.filter((link) => link.label !== 'Overview' && link.label !== 'Biography').map((link) => (
              <Link key={link.href} to={link.href}>
                  <Badge variant="outline" className="cursor-pointer px-4 py-2 text-sm hover:bg-primary/10">
                    {link.label}
                  </Badge>
              </Link>
            ))}
            </CardContent>
          </Card>
        </div>
      </div>

      <Card className="border-primary/20 bg-primary/5">
        <CardContent className="space-y-4 p-8 text-center">
          <BookOpen className="mx-auto h-12 w-12 text-primary" />
          <h2 className="text-2xl font-bold">Next steps</h2>
          <p className="text-muted-foreground">
            Use the public links below to continue reading or take action.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {publicCtas.map((cta) => (
              <Link key={cta.href} to={cta.href}>
                <Button variant={cta.href === '/media' ? 'default' : 'outline'}>
                  {cta.label}
                  {cta.href === '/media' && <ArrowRight className="ml-2 h-4 w-4" />}
                </Button>
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
